import React from "react";
import { AnalyticContainer } from "./Layout.style";

export const AnalyticLayout: React.FC = ({ children }) => (
  <AnalyticContainer>
    {children}
  </AnalyticContainer>
)
